module.exports = __webpack_public_path__ + "img/kwickk-1.cca5608c.gif";